<div class="mb-5">
  <mb-products-teaser-component
    [references$]="references$"
    [localTitle$]="localTitle$"
    [title]="title"
    [dataAnalyticsClickSource]="dataAnalyticsClickSource"
    [dataAnalyticsEventLabel]="dataAnalyticsEventLabel"
    [showBorder]="true"
  ></mb-products-teaser-component>
</div>
